import { Toaster as Sonner, toast } from "sonner";

const Toaster = () => {
  return (
    <Sonner
      theme="light"
      position="bottom-center"
      toastOptions={{
        style: {
          background: "#FFFFFF",
          color: "#1C1A3E",
          border: "1px solid #C8C8F4",
          fontSize: "14px",
        },
      }}
      style={
        {
          "--offset-bottom": "120px",
          "--width": "340px",
          "--mobile-offset-bottom": "120px",
        } as React.CSSProperties
      }
    />
  );
};

export { Toaster, toast };
